<template>
  <div>
    <vs-card class="cardx">
      <div slot="header" style="padding:10px;height: 100%;width:100%;display:flex;align-items: center;">
        <feather-icon @click="$router.go(-1)" icon="ArrowLeftIcon"  class="cursor-pointer navbar-fuzzy-search mr-4" />
        <h3>
          {{title}}
        </h3>
      </div>

      <div>
        <vs-tabs>
          <vs-tab label="Orders">
            <orders type="customer" :filters="filters" />
          </vs-tab>
        </vs-tabs>
      </div>

    </vs-card>

  </div>

</template>
<style itemscope>
  .img-inputer {
    width: 150px;
    height: 150px;
  }
</style>
<script>
  import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
  import Orders from "../orders/data";

  export default {
    name :'CustomerDetail',
    components: {
      orders: Orders
    },
    data(){
      return {
        title : 'Customer detail',
        form:{
          name: null,
          description: null
        },
        onSubmit : false,

        customer : null,
        filters : {}

      }
    },
    watch :{
      '$route.params.id': function (id) {
        this.initData();
      }
    },
    created() {
      this.filters =  {
        customer_id : this.$route.params.id,
      };
      //this.initData();
    },
    methods: {
      ...mapGetters('users',['userCan']),
      ...mapActions('customers',['fetchCustomers']),
      ...mapMutations('customers',['SET_CUSTOMERS']),
      initData(){
        if(this.$route.params.id){
          this.title = 'Edit partner';
          this.getPartner({id: this.$route.params.id})
            .then(data=>{
              this.form = data;
            })
            .catch(error=>{
              if(error){
                if(error.status === 404){
                  this.$router.push({name: 'page-error-404'});
                }
              }
            })
        }else{
          this.title = 'New customer';
          this.form = {
            name: null,
            description: null
          };
        }
      },
      msgDialog(color, title, text, action){
        this.$vs.dialog({
          color: color,
          title: title,
          text: text,
          accept:action
        })
      },
      redirectToCustomers(){
        this.$router.push({name: 'customers.list'});
      },

    },

  }
</script>
